import { render, staticRenderFns } from "./companyChart.vue?vue&type=template&id=bef07890&scoped=true&"
import script from "./companyChart.vue?vue&type=script&lang=js&"
export * from "./companyChart.vue?vue&type=script&lang=js&"
import style0 from "./companyChart.vue?vue&type=style&index=0&id=bef07890&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bef07890",
  null
  
)

export default component.exports